import { useEffect } from "react";
import { useAuth } from "@clerk/clerk-react";
import { setClerkTokenGetter, setClerkSignOut } from "../lib/api";



export const ClerkTokenProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { getToken, signOut } = useAuth();

  useEffect(() => {
    setClerkTokenGetter(getToken);
    setClerkSignOut(signOut);
  }, [getToken, signOut]);

  return <>{children}</>;
}
